module.exports = __webpack_public_path__ + "static/media/Ex2-S4-ToolAns.d3c5fb6c.png";